import detectBrowserLanguage from 'detect-browser-language';
import ProfileManager from '../api/ProfileManager';
import AuthorizationTokenStorage from '../auth/AuthorizationTokenStorage';
import { AVAILABLE_LANGUAGES } from '../exports/Constants';
import BackendApiClient from '../api/BackendApiClient';
import ReduxActions from '../../store/ReduxActions';

export const LANGUAGE_KEY = 'LANGUAGE';
export const LANGUAGE_PARAM = 'lng';

class LocalizationManager {
  getLanguage() {
    return localStorage.getItem(LANGUAGE_KEY);
  }

  saveLanguage(language) {
    localStorage.setItem(LANGUAGE_KEY, language);
    BackendApiClient.setFallbackLocale(language);

    if (AuthorizationTokenStorage.getToken()) {
      const { company } = ReduxActions.getStore().initialData;

      company?.id &&
        ProfileManager.putProfile(company?.id, {
          lang: language,
        });
    }
  }

  getLanguageFromUrl() {
    const url = window.location.href;
    const query = `${LANGUAGE_PARAM}?=`;

    if (url?.includes(query)) {
      return url?.split(query)[1] ?? null;
    }

    return null;
  }

  getPreferredLanguage() {
    const preferredBrowserLanguage = detectBrowserLanguage();
    const language = preferredBrowserLanguage?.split(/-|_/)[0];
    const defaultLanguage = AVAILABLE_LANGUAGES?.find((item) => item?.language === language)?.language;

    if (!defaultLanguage) {
      return null;
    }

    return defaultLanguage;
  }
}

export default new LocalizationManager();
